import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);
  const isTopup = searchParams.get('type') === 'topup';

  useEffect(() => {
    const timer = setTimeout(() => setProcessing(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center app-surface bg-dot-grid p-4">
        <div className="app-tile max-w-md w-full p-10 text-center">
          <div className="flex justify-center mb-5">
            <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center">
              <Loader2 className="h-7 w-7 text-primary animate-spin" />
            </div>
          </div>
          <h1 className="text-2xl font-display font-semibold mb-2 tracking-tight">Processing payment…</h1>
          <p className="text-sm text-muted-foreground">
            Please wait while we confirm your payment.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center app-surface bg-dot-grid p-4">
      <div className="app-tile max-w-md w-full p-10 text-center animate-fade-in-up">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-emerald-500/10 ring-1 ring-emerald-500/20 flex items-center justify-center">
            <CheckCircle2 className="h-9 w-9 text-emerald-600 dark:text-emerald-400" />
          </div>
        </div>

        <h1 className="text-3xl font-display font-semibold mb-3 tracking-tight">
          Payment successful
        </h1>

        <p className="text-muted-foreground mb-6">
          {isTopup
            ? "Your credits have been added to your account."
            : "Your subscription has been activated successfully."}
        </p>

        <div className="rounded-lg border border-border bg-muted/40 p-4 mb-6">
          <p className="text-sm text-muted-foreground">
            You will receive a confirmation email shortly with all the details.
          </p>
        </div>

        <Button onClick={() => navigate('/settings')} className="w-full shadow-fluent-2">
          Back to Settings
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
